import { extendObservable, action } from 'mobx';
import firebase from 'firebase';
import Log from '../models/Log';

const LogRef = firebase.database().ref("/logs");

class LogStore {
  constructor() {
    extendObservable(this, {
      userId: "",
      logs: [],
    });
  }

  getLogs = (userId) => {
    // todo: check userId
    return LogRef.child(`${userId}`)
    .orderByChild("timestamp").once("value")
    .then(action((snapshots) => {
      let logs = [];
      snapshots.forEach((snapshot) => {
        logs.push(new Log(snapshot.val()));
      });
      this.logs.replace(logs.reverse());
      return this.logs;
    }));
  };

  refresh = () => {
    // todo: this.userId?
    return this.getLogs(this.userId);
  }

  setUser = action((userId) => {
    // todo: check userId
    this.userId = userId;
    return this.getLogs(userId);
  });

  clearUser = action(() => {
    this.userId = "";
    this.logs.replace([]);
  });
}

const logStore = new LogStore();

export default logStore;
export { LogStore }; // why?


// WEBPACK FOOTER //
// ./src/stores/LogStore.js